import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import { notification } from 'antd';
import { User, Pencil, Trash2 } from 'lucide-react';

import { togglePickupUserModalAction, pickupTabAction } from '../../store/pickup';
import { pickupOtp, verifypickupotp, pickupList, deleteAuthorizedPickup } from '../../services/authrisedPickupServeice';
import { ProgramLoader } from '../reuse/SVG';
import CampsEZUser from './CampsEZUser';
import EditPickup from './editPickup';
import bannerImg from '../../assets/img/pickup-banner.png';

const BRAND = '#842014';
const BRAND_DARK = '#6b1a10';

const Pickup = props => {
  const [authrisedToPickup, setAuthrisedToPickup] = useState(false);
  const [minutes, setMinutes]                     = useState(2);
  const [seconds, setSeconds]                     = useState(0);
  const [otp, setOtp]                             = useState('');
  const [isActive, setIsActive]                   = useState(false);
  const [otpError, setOtpError]                   = useState('');
  const [pickupUserList, setPickupUserList]        = useState([]);
  const [resendpassword, setResendPassword]        = useState(false);
  const [loading, setLoading]                     = useState(true);
  const [pickuppopup, setPickuppopup]             = useState(false);
  const [deletePopup, setDeletePopup]             = useState(false);
  const [deletepickupId, setDeletePickupId]       = useState(false);
  const [editMode, setEditMode]                   = useState(false);
  const [editPickupIndex, setEditPickupIndex]     = useState();
  const [editAction, setEditAction]               = useState(false);

  useEffect(() => {
    pickupList().then(res => {
      if (res?.data?.statusCode) {
        setPickupUserList(res.data.responseData.result);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!pickuppopup) return;
    let interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes === 0) {
        clearInterval(interval);
      } else {
        setMinutes(minutes - 1);
        setSeconds(59);
      }
    }, 1000);
    return () => clearInterval(interval);
  });

  const handleChange = otp => { setOtp(otp); setOtpError(''); };

  const reSendOTP = () => {
    pickupOtp({ email: props.email }).then(() => setResendPassword(true));
    reset();
  };

  const reset = () => { setSeconds(0); setMinutes(2); };

  const handleValidate = () => {
    let validate = true;
    if (otp === '') { setOtpError('otp is required'); validate = false; }
    if (otp.toString().length !== 4) { setOtpError('otp is require length'); validate = false; }
    return validate;
  };

  const handelSubmit = e => {
    if (handleValidate()) {
      verifypickupotp({ otp }).then(res => {
        if (res.data.error) { setOtpError(res.data.error.responseMessage || 'Invalid Otp'); }
        if (res?.data?.statusCode) {
          setAuthrisedToPickup(true);
          if (!editAction) { props.togglePickupUserModalAction(); }
          setPickuppopup(false);
          localStorage.setItem('authForPickup', true);
        }
      });
    }
    e.preventDefault();
  };

  const addauthrizedPickup = () => {
    const auth_for_pickup = localStorage.getItem('authForPickup');
    if (auth_for_pickup) {
      setAuthrisedToPickup(true);
      props.togglePickupUserModalAction();
    } else {
      setPickuppopup(true);
      pickupOtp({ email: props.email });
      setEditAction(true);
    }
  };

  const editfunctionality = i => {
    const auth_for_pickup = localStorage.getItem('authForPickup');
    if (auth_for_pickup) {
      setEditMode(true);
      setEditPickupIndex(i);
    } else {
      setPickuppopup(true);
      pickupOtp({ email: props.email });
      setEditAction(true);
    }
  };

  const deletePickup = () => {
    const params = `/?pickupId=${deletepickupId}`;
    deleteAuthorizedPickup(params).then(res => {
      if (res?.data?.statusCode) {
        pickupList().then(r => {
          if (r?.data?.statusCode) setPickupUserList(r.data.responseData.result);
          setLoading(false);
        });
        notification.open({ description: 'Pickup Deleted Successfully' });
        setDeletePopup(false);
      }
    });
  };

  const deletefunctionality = id => {
    const auth_for_pickup = localStorage.getItem('authForPickup');
    if (auth_for_pickup) {
      setDeletePopup(true);
      setDeletePickupId(id);
    } else {
      setPickuppopup(true);
      pickupOtp({ email: props.email });
      setEditAction(true);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>

      {/* ── Delete confirmation modal ── */}
      <Modal show={deletePopup} animation={false} dialogClassName="folder_model" size="lg" centered>
        <Modal.Body>
          <span className="modal_close" onClick={() => setDeletePopup(false)}><i className="icon-cross" /></span>
          <div className="text-center p-5 pickup_modal_body">
            <p>Are you sure you want to delete this Pickup</p>
          </div>
          <div className="text-center p-5">
            <button onClick={() => { setDeletePickupId(''); setDeletePopup(false); }} style={{ width: 120 }} className="btn btn-light rounded-0">No</button>
            <button onClick={deletePickup} style={{ width: 120 }} className="btn btn-primary ms-3">Yes</button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ── OTP modal ── */}
      <Modal dialogClassName="text-center otp_modal" show={pickuppopup} animation={false} centered>
        <Modal.Body>
          <span className="modal_close"><i onClick={() => { setPickuppopup(false); reset(); }} className="icon-cross" /></span>
          <form className="p-5" onSubmit={handelSubmit}>
            <h3>Please Enter OTP</h3>
            <p>We have sent a One Time Password (OTP) to your Email</p>
            <div className="color-primary otp_timer">0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</div>
            <div className="otp_inputs">
              <OtpInput onChange={handleChange} isInputNum={true} shouldAutoFocus={true} name="otp" value={otp} numInputs={4} separator={''} />
              <div className="invalid-feedback">{otpError}</div>
            </div>
            <p>Didn't receive the OTP? <span onClick={reSendOTP} className="pointer color-primary">Resend</span></p>
            {resendpassword && <span>Password sent Please check you email</span>}
            <button type="submit" disabled={props.loading} className={`btn btn-primary rounded-0 w-100 mt-3 btn_anim ${props.loading ? 'show_anim' : ''}`}>
              {props.loading ? 'Loading...' : 'Verify'}
            </button>
            {props.error && <p className="error_msg">{props.error}</p>}
          </form>
        </Modal.Body>
      </Modal>

      {/* ── Hero ── */}
      <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 115px)', minHeight: 420, flexShrink: 0 }}>
        <img
          src={bannerImg}
          alt="Authorized Pickup"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(15,23,42,0.80) 0%, rgba(15,23,42,0.20) 50%, transparent 100%)',
        }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end' }}>
          <div style={{ maxWidth: 1100, width: '100%', margin: '0 auto', padding: '0 24px 80px' }}>
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', margin: 0, letterSpacing: '-0.5px' }}>
              Authorized Pickup
            </h1>
          </div>
        </div>
      </div>

      {/* ── Content ── */}
      <div style={{ maxWidth: 1100, margin: editMode ? '24px auto 0' : '-64px auto 0', padding: '0 24px 48px', position: 'relative', zIndex: 10 }}>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
            <ProgramLoader />
          </div>
        ) : editMode ? (
          <EditPickup pickupUser={pickupUserList[editPickupIndex]} />
        ) : props.pickupTab === 1 ? (
          <div className="pickup_user_wrapper"><CampsEZUser /></div>
        ) : props.pickupTab === 2 ? (
          <Redirect to="/pickup/add-non-user" />
        ) : (
          <>
            {pickupUserList.length > 0 ? (
              <div style={{ background: '#fff', borderRadius: 16, border: '1px solid rgba(226,232,240,0.6)', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                {pickupUserList.map((person, i) => (
                  <div
                    key={person._id}
                    style={{
                      padding: '20px 24px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 16,
                      borderBottom: i < pickupUserList.length - 1 ? '1px solid #f1f5f9' : 'none',
                    }}
                  >
                    {/* Avatar + info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 20, flex: 1, minWidth: 0 }}>
                      {person.profileImage ? (
                        <img
                          src={person.profileImage}
                          alt={person.firstName}
                          style={{ width: 52, height: 52, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '1px solid #e2e8f0' }}
                        />
                      ) : (
                        <div style={{
                          width: 52, height: 52, borderRadius: '50%', flexShrink: 0,
                          background: '#f1f5f9', border: '1px solid #e2e8f0',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: '#94a3b8',
                        }}>
                          <User size={24} />
                        </div>
                      )}

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h3 style={{ fontSize: '1.0625rem', fontWeight: 600, color: '#0f172a', margin: '0 0 6px' }}>
                          {person.firstName} {person.lastName}
                        </h3>
                        {person?.campers?.length > 0 && (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            {person.campers.map((camper, ci) => (
                              <div key={ci} style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px', fontSize: '0.875rem', color: '#64748b' }}>
                                <span>
                                  <span style={{ fontWeight: 600, color: '#334155' }}>Participant: </span>
                                  {camper.camperName}
                                </span>
                                <span style={{ color: '#cbd5e1' }}>•</span>
                                <span>
                                  <span style={{ fontWeight: 600, color: '#334155' }}>Relationship: </span>
                                  {camper.relationship}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                      <button
                        onClick={() => editfunctionality(i)}
                        style={{
                          padding: 10, background: 'transparent', border: 'none', borderRadius: 10,
                          color: '#94a3b8', cursor: 'pointer', transition: 'color 0.2s, background 0.2s',
                          display: 'flex', alignItems: 'center',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.color = '#3b82f6'; e.currentTarget.style.background = '#eff6ff'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.background = 'transparent'; }}
                        aria-label={`Edit ${person.firstName}`}
                      >
                        <Pencil size={18} />
                      </button>
                      <button
                        onClick={() => deletefunctionality(person._id)}
                        style={{
                          padding: 10, background: 'transparent', border: 'none', borderRadius: 10,
                          color: '#94a3b8', cursor: 'pointer', transition: 'color 0.2s, background 0.2s',
                          display: 'flex', alignItems: 'center',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.background = '#fef2f2'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.background = 'transparent'; }}
                        aria-label={`Delete ${person.firstName}`}
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ background: '#fff', borderRadius: 16, border: '1px solid rgba(226,232,240,0.6)', padding: '48px 24px', textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                <img src={require('../../assets/img/pickup-img.png')} alt="No pickups" style={{ maxWidth: 180, margin: '0 auto 24px', display: 'block' }} />
                <h3 style={{ color: BRAND, fontWeight: 600, marginBottom: 8 }}>Add Authorized Pickup</h3>
                <p style={{ color: '#64748b', marginBottom: 0 }}>There is no Authorized pickup added right now.</p>
              </div>
            )}

            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
              <button
                onClick={addauthrizedPickup}
                style={{
                  background: BRAND, color: '#fff', border: 'none', borderRadius: 8,
                  padding: '12px 32px', fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer',
                  width: '100%', maxWidth: 360,
                }}
                onMouseEnter={e => e.currentTarget.style.background = BRAND_DARK}
                onMouseLeave={e => e.currentTarget.style.background = BRAND}
              >
                Add Authorized Pickup
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { pickupTab } = state.pickup;
  const email = state.user.userProfile.email;
  return { pickupTab, email };
};

const mapDispatchToProps = dispatch => ({
  togglePickupUserModalAction: () => dispatch(togglePickupUserModalAction()),
  pickupTabAction: params => dispatch(pickupTabAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pickup);
